import React from 'react';
import ModuleGate from '../../components/ModuleGate';
import StandaloneShell from '../../components/StandaloneShell';

function ComingSoonBody({ title, description, T }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '70vh', textAlign: 'center', padding: 24 }}>
      <div style={{ maxWidth: 420 }}>
        <div style={{ width: 56, height: 56, borderRadius: '50%', background: T.bg3, border: `1px solid ${T.border2}`, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>
          </svg>
        </div>
        <h3 style={{ fontSize: 17, fontWeight: 700, color: T.text, margin: '0 0 8px' }}>{title} — coming soon</h3>
        <p style={{ fontSize: 13, color: T.text3, margin: 0, lineHeight: 1.6 }}>{description}</p>
      </div>
    </div>
  );
}

// Generic placeholder for workspace modules that are seeded/subscribable but
// not yet built. Still gated by ModuleGate so Super Admin can pre-provision
// firm access ahead of the real feature shipping.
export default function ComingSoonPage({ moduleKey, moduleName, description }) {
  const token = localStorage.getItem('token');
  return (
    <ModuleGate moduleKey={moduleKey} moduleName={moduleName} token={token}>
      <StandaloneShell title={moduleName}>
        {({ T }) => <ComingSoonBody title={moduleName} description={description} T={T} />}
      </StandaloneShell>
    </ModuleGate>
  );
}
